// extracted by mini-css-extract-plugin
export default {"root":"ViewAllOrders_root__ar1e3","resultsContainer":"ViewAllOrders_resultsContainer__vXW7F","filterContainer":"ViewAllOrders_filterContainer__A6yKJ"};